<form [formGroup]="journalForm" #formDirective="ngForm" (ngSubmit)="save()">
  @if (isCreateModal()) {
    <div class="journal-entry-details-create">
      @if (journalForm.value.wrongContentInfo) {
        <div class="errorMessage">
          <div class="wrongInfoTitle">{{ i18n.get('toCorrect') }}</div>
          <div class="wrongInfo">{{ journalForm.value.wrongContentInfo }}</div>
        </div>
      }
      @if (!entry()) {
        <mat-card class="entry-message-number">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('messageNumber') }}</mat-label>
            <input matInput type="number" formControlName="messageNumber" />
            @if (journalForm.controls.messageNumber.hasError('messageNumberExists')) {
              <mat-error>{{ i18n.get('messageNumberAlreadyExists') }}</mat-error>
            }
          </mat-form-field>
          <div class="message-number-hint">{{ i18n.get('messageNumberAutoGenerated') }}</div>
          <mat-checkbox [checked]="manualMessageNumber()" (change)="toggleManualMessageNumber($event.checked)">
            {{ i18n.get('messageNumberManualEntry') }}
          </mat-checkbox>
        </mat-card>
      }
      <mat-card>
        <app-form-section>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('deliverer') }}</mat-label>
            <input matInput formControlName="sender" #senderInput cdkFocusInitial />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('receiver') }}</mat-label>
            <input matInput formControlName="creator" />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('date') }}</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dateCreatedDate" />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('time') }}</mat-label>
            <input matInput [matTimepicker]="pickerTime" formControlName="dateCreatedTime" (input)="normalizeTimeInput($event)" />
            <mat-timepicker-toggle matIconSuffix [for]="pickerTime" />
            <mat-timepicker #pickerTime />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" data-testid="communicationDevice">
            <mat-label>{{ i18n.get('communicationDevice') }}</mat-label>
            <mat-select matNativeControl formControlName="communicationType" [attr.aria-label]="i18n.get('communicationDevice')">
              <mat-option>{{ i18n.get('noInfo') }}</mat-option>
              @for (item of CommunicationTypeValues | keyvalue; track item.key) {
                <mat-option [value]="item.key">{{ i18n.get(item.value) }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('detailsChanel') }}</mat-label>
            <input matInput formControlName="communicationDetails" />
          </mat-form-field>
        </app-form-section>
      </mat-card>
      
      <mat-card>
        <app-form-section>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('messageSubject') }}</mat-label>
            <input matInput formControlName="messageSubject" />
          </mat-form-field>
          <app-text-area-with-address-search
            #messageContent
            [label]="i18n.get('messageContent')"
            [formVisible]="formVisible()"
            [messageContentControl]="messageContentControl"
          ></app-text-area-with-address-search>
        </app-form-section>
      </mat-card>
        
      <mat-card>
        <app-form-section>
          <mat-form-field class="visa" appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('visa') }}</mat-label>
            <input matInput formControlName="visumMessage" />
          </mat-form-field>
        </app-form-section>
      </mat-card>
      <!-- allow to submit with enter on modal form -->
      <button type="submit" style="display:none" [disabled]="submitting()"></button>
    </div>
  } @else {
  
  <div class="sidebar-header">
    <div>
      <p>{{ journalForm.value.dateCreatedDate?.toLocaleString() }}</p>
      <h1>
        <span class="message-number">#{{ journalForm.value.messageNumber }}</span>
        {{ journalForm.value.messageSubject ?? '' }}
      </h1>
    </div>

    <button type="button" (click)="closeForm()" mat-icon-button [attr.aria-label]="i18n.get('close')">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="eingang-content">
    <h2>{{ i18n.get('input') }}</h2>
    <div class="info-row">
      <div class="journal-section ">
        <p><strong>{{ i18n.get('deliverer') }}</strong></p>
        <p>{{ journalForm.value.sender }}</p>
      </div>
      <div class="journal-section ">
        <p><strong>{{ journalForm.value.communicationType }}</strong></p>
        <p>{{ journalForm.value.communicationDetails }}</p>
      </div>
      <div class="journal-section ">
        <p><strong>{{ i18n.get('receiver') }}</strong></p>
        <p>{{ journalForm.value.creator }}</p>
      </div>
      <div class="journal-section">
        <p><strong>{{ i18n.get('visa') }}</strong></p>
        <p>{{ journalForm.value.visumMessage }}</p>
      </div>
    </div>
    <div class="journal-section info">
      <p><strong>{{ i18n.get('messageContent') }}</strong></p>
      <div
        class="preserve-linebreak"
        [innerHTML]="journalForm.value.messageContent | replaceAllAddressTokens : true"
        (click)="search.handleMessageContentClick($event)"
      ></div>
    </div>
  </div>
  }

  @if (journalForm.value.entryStatus !== JournalEntryStatus.AWAITING_MESSAGE){
    <mat-divider></mat-divider>
    <div class="triage-content">
      <h2>{{ i18n.get('triage') }}</h2>

      @if (journalForm.value.entryStatus !== JournalEntryStatus.AWAITING_TRIAGE || isReadOnly()) {
        <div class="info-row">
          <div class="journal-section ">
            <p><strong>{{ i18n.get('keyMessage') }}</strong></p>
            <p>{{
              journalForm.value.isKeyMessage !== undefined ?
                journalForm.value.isKeyMessage ?
                  i18n.get('yes')
                : i18n.get('no')
              : ''
            }}</p>
          </div>
          <div class="journal-section">
            <p><strong>{{ i18n.get('department') }}</strong></p>
            <p>{{ journalForm.value.department ? i18n.get(journalForm.value.department) : '' }}</p>
          </div>
          <div class="journal-section ">
            <p><strong>{{ i18n.get('dateTriage') }}</strong></p>
            <p>{{ journalForm.value.dateTriage?.toLocaleString() }}</p>
          </div>
          <div class="journal-section">
            <p><strong>{{ i18n.get('visa') }}</strong></p>
            <p>{{ journalForm.value.visumTriage }}</p>
          </div>
        </div>
      } @else {
        <div class="journal-entry-details">
          @if (journalForm.value.wrongTriageInfo) {
            <div class="errorMessage">
              <strong><p>{{ i18n.get('wrongTriageInfo') }}</p></strong>
              <p class="wrongInfo">{{ journalForm.value.wrongTriageInfo }}</p>
            </div>
          }

          <div class="row journal-section">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ i18n.get('department') }}</mat-label>
              <mat-select formControlName="department" >
                <mat-option>{{ i18n.get('noDepartment') }}</mat-option>
                @for (department of DepartmentValues; track $index) {
                  <mat-option [value]="department">{{ i18n.get(department) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
              <mat-checkbox class="journal-entry-checkbox" formControlName="isKeyMessage">{{
                i18n.get('keyMessage')
              }}</mat-checkbox>
          </div>

          <div class="row journal-section">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ i18n.get('visa') }}</mat-label>
              <input matInput formControlName="visumTriage" />
            </mat-form-field>
          </div>
          <div class="journal-entry-save-buttons">
            @if (showPrint) {
              <button
                mat-icon-button
                [attr.aria-label]="i18n.get('print')"
                [attr.title]="i18n.get('print')"
                (click)="print($event)"
                type="button"
              >
                <mat-icon>print</mat-icon>
              </button>
            }
            <button mat-flat-button color="primary" type="submit" [disabled]="submitting()">
              <mat-icon>check</mat-icon>
              {{ i18n.get('save') }}
            </button>
          </div>

          <div class="info-send-back">
            <h3>{{ i18n.get('wrongContent') }}</h3>
            <p>{{ i18n.get('wrongContentMessage') }}</p>
        
            <mat-form-field appearance="outline" >
              <mat-label>{{ i18n.get('wrongContentInfo') }}</mat-label>
              <input matInput formControlName="wrongContentInfo" (keydown.enter)="onEnterForResetState($event)" />
            </mat-form-field>
        
            <button mat-button type="button" (click)="resetState()" [disabled]="submitting()">{{ i18n.get('backToInput') }}</button>
          </div>
        </div>
      }
    </div>
  }

  @if (journalForm.value.entryStatus !== JournalEntryStatus.AWAITING_MESSAGE && journalForm.value.entryStatus !== JournalEntryStatus.AWAITING_TRIAGE){
    <mat-divider></mat-divider>
    <div class="decision-content">
      <h2>{{ i18n.get('decision') }}</h2>
    
      @if (journalForm.value.entryStatus === JournalEntryStatus.AWAITING_COMPLETION || journalForm.value.entryStatus === JournalEntryStatus.COMPLETED || isReadOnly()){
        <div class="info-row">
          <div class="journal-section">
            <p><strong>{{ i18n.get('messageReceiver') }}</strong></p>
            <p>{{ journalForm.value.decisionReceiver }}</p>
          </div>
          <div class="journal-section ">
            <p><strong>{{ i18n.get('dateDecision') }}</strong></p>
            <p>{{ journalForm.value.dateDecision?.toLocaleString() }}</p>
          </div>
          <div class="journal-section">
            <p><strong>{{ i18n.get('visa') }}</strong></p>
            <p>{{ journalForm.value.visumDecider }}</p>
          </div>
        </div>
        <div class="info-row">
          <div class="journal-section ">
            <p><strong>{{ i18n.get('decision') }}</strong></p>
            <p>{{ journalForm.value.decision }}</p>
          </div>
        </div>
      } @else {
      <div class="journal-entry-details">
        <div class="journal-section">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('decision') }}</mat-label>
            <textarea matInput formControlName="decision" rows="10"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('messageReceiver') }}</mat-label>
            <input matInput formControlName="decisionReceiver" />
          </mat-form-field>
        </div>
        
        <div class="row journal-section">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('visa') }}</mat-label>
            <input matInput formControlName="visumDecider" />
          </mat-form-field>

          <div class="journal-entry-save-buttons">
            @if (showPrint) {
              <button
                mat-icon-button
                [attr.aria-label]="i18n.get('print')"
                [attr.title]="i18n.get('print')"
                (click)="print($event)"
                type="button"
              >
                <mat-icon>print</mat-icon>
              </button>
            }
            <button mat-flat-button color="primary" type="submit" [disabled]="submitting()">
              <mat-icon>check</mat-icon>
              {{ i18n.get('save') }}
            </button>
          </div>
        </div>

        <div class="info-send-back">
          <h3>{{ i18n.get('wrongDepartment') }}</h3>
          <p>{{ i18n.get('wrongTriage') }}</p>
    
          <mat-form-field appearance="outline">
            <mat-label>{{ i18n.get('wrongTriageInfo') }}</mat-label>
            <input matInput formControlName="wrongTriageInfo" (keydown.enter)="onEnterForResetState($event)" />
          </mat-form-field>
    
          <button mat-button type="button" (click)="resetState()" [disabled]="submitting()">{{ i18n.get('backToTriage') }}</button>
        </div>
      </div>
    }
    </div>
  }

  @if (journalForm.value.entryStatus === JournalEntryStatus.AWAITING_COMPLETION || journalForm.value.entryStatus === JournalEntryStatus.COMPLETED || isReadOnly()) {
    <mat-divider></mat-divider>
    <div class="output-content">
      <h2>{{ i18n.get('output') }}</h2>
    
      @if (journalForm.value.entryStatus === JournalEntryStatus.COMPLETED || isReadOnly()) {
        <div class="info-row">
          <div class="journal-section ">
            <p><strong>{{ i18n.get('deliveredFrom') }}</strong></p>
            <p>{{ journalForm.value.decisionSender }}</p>
          </div>
          <div class="journal-section ">
            <p><strong>{{ i18n.get('deliveryTime') }}</strong></p>
            <p>{{ journalForm.value.dateDecisionDelivered?.toLocaleString() }}</p>
          </div>
        </div>
      } @else {
        <div class="row journal-section">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ i18n.get('deliveredFrom') }}</mat-label>
            <input matInput formControlName="decisionSender" />
          </mat-form-field>

          <div class="journal-entry-save-buttons">
            @if (showPrint) {
              <button
                mat-icon-button
                [attr.aria-label]="i18n.get('print')"
                [attr.title]="i18n.get('print')"
                (click)="print($event)"
                type="button"
              >
                <mat-icon>print</mat-icon>
              </button>
            }
            <button mat-flat-button color="primary" type="submit" [disabled]="submitting()">
              <mat-icon>check</mat-icon>
              {{ i18n.get('save') }}
            </button>
          </div>
        </div>
      }
    </div>
  }
</form>
